import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";

import "./stylesCarousel.scss";

import { FreeMode, Navigation, Thumbs, Autoplay, Pagination } from "swiper";
import { useMediaQuery } from "@mui/material";
import { ScalableImage } from "design_system/src";

export const VehicleCarousel: React.FC<any> = ({ photos }) => {
  const [thumbsSwiper, setThumbsSwiper] = useState<any>();

  const showingBullets: number = 4;
  const remainingPhotos: number = photos.length - showingBullets;
  const magnifierWidth = window.innerWidth / 2 - 200;
  const magnifierHeight = 500;
  const zoom = 3;

  const matchesXS = useMediaQuery("(min-width:600px)");

  const [showMagnifier, setShowMagnifier] = useState(false);
  const [[imgWidth, imgHeight], setSize] = useState([0, 0]);
  const [[x, y], setXY] = useState([0, 0]);
  const [url, setUrl] = useState("");

  const onMouseEnter = (e: any, itemUrl: string) => {
    const element = e.currentTarget;
    const { width, height } = element.getBoundingClientRect();
    setSize([width, height]);
    setShowMagnifier(true);
    setUrl(itemUrl);
  };

  const onMouseLeave = (e: any) => {
    e.preventDefault();
    setShowMagnifier(false);
  };

  const onMouseMove = (e: any) => {
    const element = e.currentTarget;
    const { top, left } = element.getBoundingClientRect();
    const valueX = e.pageX - left - window.scrollX;
    const valueY = e.pageY - top - window.scrollY;
    setXY([valueX, valueY]);
  };

  return (
    <div
      className="pos_relative"
      style={{
        height: !matchesXS ? "auto" : "auto",
        backgroundColor: "white",
        borderRadius: !matchesXS ? "0" : "10px",
        boxShadow: !matchesXS
          ? ""
          : "2px 4px 8px rgba(34, 38, 42, 0.05), 4px 8px 24px rgba(34, 38, 42, 0.1)",
      }}
    >
      <Swiper
        onSwiper={setThumbsSwiper}
        spaceBetween={10}
        thumbs={{ swiper: thumbsSwiper }}
        modules={[Autoplay, Pagination, Navigation, Thumbs]}
        pagination={{
          dynamicBullets: true,
        }}
        navigation
        loop={!matchesXS}
        grabCursor
        className="mySwiper2"
        style={{
          height: "50vh",
          marginBottom: "0",
          borderRadius: !matchesXS ? 0 : 10,
          padding: !matchesXS ? 0 : 10,
        }}
      >
        {photos.map((item: any, idx: number) => (
          <SwiperSlide key={`slide-${idx}`} className="vehicleMainSlide">
            <ScalableImage
              desktopWidth={50}
              mobileWidth={100}
              src={item.url}
              alt={`cImg-${idx}`}
              className={`vehicleMainSlide__image${
                matchesXS ? " js-small-image" : ""
              }`}
              onMouseEnter={(e) => onMouseEnter(e, item.url)}
              onMouseLeave={(e) => onMouseLeave(e)}
              onMouseMove={(e) => onMouseMove(e)}
            />
          </SwiperSlide>
        ))}
      </Swiper>

      <div
        style={{
          display: showMagnifier ? "" : "none",
          position: "absolute",
          pointerEvents: "none",
          height: `${magnifierHeight}px`,
          width: `${magnifierWidth}px`,
          opacity: "1",
          backgroundImage: `url(${url})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: `${imgWidth * zoom}px ${imgHeight * zoom}px`,
          backgroundPositionX: `${-x * zoom + magnifierWidth / 2}px`,
          backgroundPositionY: `${-y * zoom + magnifierHeight / 2}px`,
          top: 0,
          left: "105%",
          zIndex: 10,
        }}
      />

      <Swiper
        initialSlide={1}
        onSwiper={setThumbsSwiper}
        spaceBetween={10}
        slidesPerView={showingBullets}
        freeMode={false}
        loop={false}
        watchSlidesProgress
        modules={[Autoplay, FreeMode, Navigation, Thumbs]}
        className="mySwiper display_none_mobile"
      >
        {photos.map((item: any, idx: number) => {
          if (idx === 3 && photos.length > showingBullets) {
            return (
              <SwiperSlide
                key={`thumbnail-slide-${idx}`}
                className="vehicleSwiperSlide vehicleSwiperSlide__thumbnail"
              >
                <ScalableImage
                  desktopWidth={10}
                  mobileWidth={25}
                  src={item.url}
                  alt={`cImg-${idx}`}
                />

                <div className="vehicleSwiperSlide__thumbnail-text-container flex_center">
                  <div className="vehicleSwiperSlide__thumbnail-text">
                    {`+${remainingPhotos + 1}`}
                  </div>
                </div>
              </SwiperSlide>
            );
          }
          if (idx < showingBullets) {
            return (
              <SwiperSlide key={`cImg-${idx}`} className="vehicleSwiperSlide">
                <ScalableImage
                  desktopWidth={10}
                  mobileWidth={25}
                  src={item.url}
                  alt={`cImg-${idx}`}
                />
              </SwiperSlide>
            );
          }
          return <React.Fragment key={`cImg-${idx}`} />;
        })}
      </Swiper>
    </div>
  );
};

export default VehicleCarousel;
